import { Component } from 'preact'
/* eslint-disable import/no-internal-modules */
import Header from '@insided/deprecated-control/header'
import axios from 'axios'
import AlertBox, { MessageTypes } from '@insided/deprecated-preact-components/design-system-components/message'
import GeneralPanel from '@insided/control/modules/CustomPages/GeneralPanel'
import SEOPanel from '@insided/control/modules/CustomPages/SEOPanel'

interface State {
    title: string
    slug: string
    metaName: string
    metaDescription: string
    alertMessage: string
    alertMessageType?: null | MessageTypes
    requiredFieldsError: {
        title: boolean
        slug: boolean
    }
    loading: boolean
}

export class CustomPageAdd extends Component<{}, State> {
    constructor () {
        super()
        this.state = {
            title: '',
            slug: '',
            metaName: '',
            metaDescription: '',
            alertMessage: '',
            alertMessageType: null,
            requiredFieldsError: {
                title: false,
                slug: false
            },
            loading: false
        }

        this.createNewCustomPage = this.createNewCustomPage.bind(this)
    }

    async createNewCustomPage() {
        const { title, slug, metaName, metaDescription } = this.state
        if (!title || !slug) {
            this.setState({
                 requiredFieldsError: {
                    title: !title,
                    slug: !slug
                }
            })
            return
        }

        try {
            this.setState({
                loading: true
            })

            const response = await axios.post('/platform/custom-pages/new', {
                title,
                slug: slug.replace(/^\//g, ''),
                seo_fields: {
                    name: metaName,
                    description: metaDescription
                }
            }, {
                validateStatus: (state: number) => {
                    return (state >= 200 && state < 300) || state === 422
                }
            })
            this.setState({
                loading: false
            })
            if (response.status === 422) {
                this.setState({
                    alertMessageType: 'error',
                    alertMessage: response.data.error
                })
            } else {
                window.location.assign('/platform/custom-pages?success=true')
            }
        } catch (e) {
            this.setState({
                loading: false,
                alertMessageType: 'error',
                alertMessage: 'Something went wrong'
            })
        }
    }

    render () {
        const { alertMessageType, alertMessage, requiredFieldsError, loading } = this.state
        return (
          <div className='custom-pages-new-page'>
            {alertMessageType && (
              <AlertBox isControl variant={alertMessageType} onDismiss={() => this.setState({ alertMessageType: null })} timer={3000}>
                {alertMessage}
              </AlertBox>
              )}
            <Header
              title='New Page'
              hasBreadcrumb
              isLoading={loading}
              breadcrumbText='Back to Custom Pages Main'
              breadcrumbLink='/platform/custom-pages'
              saveCallback={this.createNewCustomPage}
              cancelCallback={() => {
                  window.location.href = '/platform/custom-pages'
              }}
            />
            <GeneralPanel
              title=''
              slug=''
              requiredFieldsError={requiredFieldsError}
              onTitleChange={(value) => this.setState({ title: value })}
              onSlugChange={(value) => this.setState({ slug: value })}
            />
            <SEOPanel
              name=''
              description=''
              onNameChange={(value) => this.setState({ metaName: value })}
              onDescriptionChange={(value) => this.setState({ metaDescription: value })}
            />
          </div>
    )
  }
}

export default CustomPageAdd
